export default ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#E5E7EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.69844 9.10769C9.37218 9.10769 9.10769 9.37218 9.10769 9.69844V30.3009C9.10769 30.6271 9.37218 30.8916 9.69844 30.8916H22.8799V15.4213C22.8799 15.1154 23.1278 14.8675 23.4337 14.8675C23.7396 14.8675 23.9876 15.1154 23.9876 15.4213V18.3019H26.8677C27.1736 18.3019 27.4216 18.5499 27.4216 18.8558C27.4216 19.1616 27.1736 19.4096 26.8677 19.4096H23.9878L23.9876 30.8917L30.3016 30.8923C30.3015 30.8923 30.3016 30.8923 30.3016 30.8923C30.6278 30.8923 30.8923 30.6278 30.8923 30.3016V19.4096H30.3015C29.9957 19.4096 29.7477 19.1616 29.7477 18.8558C29.7477 18.5499 29.9957 18.3019 30.3015 18.3019H31.4462C31.752 18.3019 32 18.5499 32 18.8558V30.3016C32 31.2396 31.2396 32 30.3016 32L9.69844 31.9993C8.76041 31.9993 8 31.2389 8 30.3009V9.69844C8 8.76041 8.76042 8 9.69844 8H22.2891C23.2271 8 23.9876 8.76041 23.9876 9.69843C23.9876 10.0043 23.7396 10.2523 23.4337 10.2523C23.1278 10.2523 22.8799 10.0043 22.8799 9.69843C22.8799 9.37217 22.6154 9.10769 22.2891 9.10769H9.69844Z"
      fill="#1F2A37"
    />
  </svg>
);
